import { render, staticRenderFns } from "./WarehouseCodeMapping.vue?vue&type=template&id=46bc31c4"
import script from "./WarehouseCodeMapping.vue?vue&type=script&lang=js"
export * from "./WarehouseCodeMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46bc31c4')) {
      api.createRecord('46bc31c4', component.options)
    } else {
      api.reload('46bc31c4', component.options)
    }
    module.hot.accept("./WarehouseCodeMapping.vue?vue&type=template&id=46bc31c4", function () {
      api.rerender('46bc31c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/erp/WarehouseCodeMapping.vue"
export default component.exports